<template>
  <div class="text-center" :class="{'fullscrean': full}">
    <div class="mt-3">
      <div class="dot-flashing"></div>
      <div class="text-muted font-weight-bold small mt-3" v-show="text">{{text !== true ? text : 'Carregando os dados'}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "loading",
    props: ['full', 'text']
  }
</script>

<style scoped>
.fullscrean {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
}
.dot-flashing {
  margin: auto;
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--primary);
  color: var(--primary);
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: .5s;
}

.dot-flashing::before, .dot-flashing::after {
  content: '';
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--primary);
  color: var(--primary);
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: var(--primary);
  color: var(--primary);
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: var(--primary);
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
</style>
